export interface IEventTypeResponse {
  Id: number
  Title: string
  IsDefault: boolean
  CoHost?: {
    Name: string
    Email: string
  }
}

export function eventTypeTranslationKey(id: number) {
  switch (id) {
    case 1:
      return "event_details_form.event_types.wedding" as const
    case 2:
      return "event_details_form.event_types.engagement_party" as const
    case 3:
      return "event_details_form.event_types.party" as const
    case 4:
      return "event_details_form.event_types.corporate" as const
    case 5:
      return "event_details_form.event_types.holiday" as const
    case 6:
      return "event_details_form.event_types.festival" as const
    case 7:
      return "event_details_form.event_types.other" as const
    case 8:
      return "event_details_form.event_types.memorial" as const
    default:
      return undefined
  }
}

export class EventType {
  public id: number
  public title?: string
  public isDefault?: boolean
  public coHost?: { name: string, email: string }

  constructor(eventType: EventType) {
    this.id = eventType.id
    this.title = eventType.title
    this.isDefault = eventType.isDefault
    this.coHost = eventType.coHost
  }

  public get translationKey() {
    return eventTypeTranslationKey(this.id)
  }

  public static fromResponse(response: IEventTypeResponse) {
    const eventType = new EventType({} as EventType)

    eventType.id = response.Id
    eventType.title = response.Title
    eventType.isDefault = response.IsDefault
    eventType.coHost = response.CoHost ? { name: response.CoHost.Name, email: response.CoHost.Email } : undefined

    return eventType
  }
}
